import type { AuthenticationToken } from "../../core/types";
import { getErrorStatus } from "../utils/getErrorStatus";

export type WidgetTokenResult =
  | { success: true; widgetToken: AuthenticationToken }
  | { success: false; status: number | undefined };

export const createWidgetToken = async (
  apiUrl: string,
  signal: AbortSignal,
): Promise<WidgetTokenResult> => {
  const url = new URL(`${apiUrl}/widget_tokens`);

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      signal,
    });

    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`, {
        cause: response.status,
      });
    }

    const widgetToken = (await response.json()) as AuthenticationToken;
    return { success: true, widgetToken };
  } catch (error) {
    return { success: false, status: getErrorStatus(error) };
  }
};
